import React, { useEffect } from "react";
import { Box, Grid, Typography, Divider } from "@material-ui/core";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import moment from "moment";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "28px",
    },
    fdataRow: {
      padding: "2px",
      marginBottom: "10px",
    },
    customFeq: {
      float: "left",
      maxWidth: "6.5%",
    },
    customFeqHeading: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "20px",
      float: "left",
      marginRight: "10px",
      width: "100%",
      textAlign: "center",
      textTransform: "uppercase",
    },
    customFeqText: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightRegular,
      color: "rgba(0, 0, 0, 0.54)",
      lineHeight: "20px",
      textAlign: "center",
    },
    FreqLabel: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
      color: "rgba(0, 0, 0, 0.54)",
      lineHeight: "20px",
      textAlign: "left",
      paddingLeft: "10px",
      marginTop: "4px",
      marginBottom: "8px",
    },
    FreqValue: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightRegular,
      color: "rgba(0, 0, 0, 0.54)",
      lineHeight: "20px",
      textAlign: "left",
      paddingLeft: "10px",
      marginTop: "4px",
      marginBottom: "8px",
    },
  })
);

export function MonthlyFrequency({ data }: any): React.ReactElement {
  const classes = useStyles();

  const {
    apr,
    aug,
    category,
    dece,
    feb,
    jan,
    jul,
    jun,
    mar,
    may,
    nextYear,
    nov,
    oct,
    recurNo,
    sep,
    task,
    thisYear,
  } = data;

  const freqData = [
    {
      name: "Recur #",
      number: recurNo,
    },
    {
      name: "Task",
      number: task,
    },
    {
      name: "Category",
      number: category,
    },
    {
      name: "JAN",
      number: jan || 0,
    },
    {
      name: "FEB",
      number: feb || 0,
    },
    {
      name: "MAR",
      number: mar || 0,
    },
    {
      name: "APR",
      number: apr || 0,
    },
    {
      name: "MAY",
      number: may || 0,
    },
    {
      name: "JUN",
      number: jun || 0,
    },
    {
      name: "JUL",
      number: jul || 0,
    },
    {
      name: "AUG",
      number: aug || 0,
    },
    {
      name: "SEP",
      number: sep || 0,
    },
    {
      name: "OCT",
      number: oct || 0,
    },
    {
      name: "NOV",
      number: nov || 0,
    },
    {
      name: "DEC",
      number: dece || 0,
    },
  ];

  return (
    <>
      <Grid container direction="row">
        <Grid item xs={12} md={12}>
          <Grid container direction="row">
            <Grid item xs={12} md={12}>
              <Box mb={1} />
              <Divider />
              <Box mb={1} />
            </Grid>
          </Grid>
          <Grid item xs={12} md={8}>
            <Grid container direction="row">
              <Grid item xs={12} md={3}>
                <Grid container direction="row">
                  <Grid item xs={12} md={8}>
                    <Box color="text.secondary">
                      <Typography className={classes.FreqLabel}>This Year</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box color="secondary.main">
                      <Typography className={classes.FreqValue}>{thisYear}</Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={3}>
                <Grid container direction="row">
                  <Grid item xs={12} md={8}>
                    <Box color="text.secondary">
                      <Typography className={classes.FreqLabel}>Next Year</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box color="secondary.main">
                      <Typography className={classes.FreqValue}>{nextYear}</Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container direction="row" className={classes.fdataRow}>
            {freqData.map((item, i) => (
              <Grid item xs={1} className={classes.customFeq} key={i}>
                <Grid container direction="row">
                  <Grid item xs={12} md={12}>
                    <Box color="text.secondary">
                      <Typography className={classes.customFeqHeading}>{item.name}</Typography>
                    </Box>
                    <Box color="secondary.main">
                      <Typography className={classes.customFeqText}>{item.number}</Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
